// extracted by mini-css-extract-plugin
export var container = "OurMission-module__container___vW6RC";
export var content = "OurMission-module__content___xYG6w";
export var img = "OurMission-module__img___qLI4O";
export var mission = "OurMission-module__mission___bW3YX";
export var text = "OurMission-module__text___vzRKr";